// extracted by mini-css-extract-plugin
export default {"main-container":"oUKu6ZXpGuyo0V0lZuGXvQ==","content":"_0VpkZO6dgkHd5NA+6KVI7A==","illustration":"UH+9J+AQftNYdtWergwGyA=="};